/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';

/**
 * 
 * @export
 * @interface CreateOtherMedicalSystemDto
 */
export interface CreateOtherMedicalSystemDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMedicalSystemDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMedicalSystemDto
     */
    description?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof CreateOtherMedicalSystemDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateOtherMedicalSystemDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMedicalSystemDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMedicalSystemDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMedicalSystemDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherMedicalSystemDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherMedicalSystemDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOtherMedicalSystemDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMedicalSystemDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof CreateOtherMedicalSystemDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMedicalSystemDto
     */
    trackItAlias?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMedicalSystemDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMedicalSystemDto
     */
    $type?: CreateOtherMedicalSystemDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOtherMedicalSystemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsCreateOtherMedicalSystemDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMedicalSystemDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOtherMedicalSystemDtoTypeEnum = typeof CreateOtherMedicalSystemDtoTypeEnum[keyof typeof CreateOtherMedicalSystemDtoTypeEnum];



/**
 * Check if a given object implements the CreateOtherMedicalSystemDto interface.
 */
export function instanceOfCreateOtherMedicalSystemDto(value?: unknown): value is CreateOtherMedicalSystemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOtherMedicalSystemDtoTypeEnum)[0];
}

export function CreateOtherMedicalSystemDtoFromJSON(json: any): CreateOtherMedicalSystemDto {
    return CreateOtherMedicalSystemDtoFromJSONTyped(json, false);
}

export function CreateOtherMedicalSystemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherMedicalSystemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'typeSpecification': json['typeSpecification'] == null ? undefined : json['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'trackItAlias': json['trackItAlias'] == null ? undefined : json['trackItAlias'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateOtherMedicalSystemDtoToJSON(value?: CreateOtherMedicalSystemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'category': RtSystemCategoryToJSON(value['category']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'imageId': value['imageId'],
        'isAvailable': value['isAvailable'],
        'isArchived': value['isArchived'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'typeSpecification': value['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryToJSON(value['subCategory']),
        'trackItAlias': value['trackItAlias'],
        'serialNumber': value['serialNumber'],
        '$type': value['$type'],
    });
}

